<template>
    <div class="visible">
        <ContentBox title="全价值链智能信息化系统" text="鲲鹏数据平台(实时数据采集，分析可视平台)+鲲鹏云套件(云网关、云订单、云仓储、云配送等)，实现智能订单拆单拼单、精细化仓库管理、全程跟踪可视运输配送，所有单据实现移动电子回传，改善库存布局，提升作业效率">
            <div class="system">
                <div class="content">
                    <div class="info">
                        <img class="icon" src="../../images/icon/icon_qlc.png">
                        <div class="text">
                            <h5>全流程</h5>
                            <p>赋能全业务流程，从订单接入，仓储管理，运输调配，实时计费完整流程支撑</p>
                        </div>
                    </div>
                    <div class="info">
                        <img class="icon" src="../../images/icon/icon_ydh.png">
                        <div class="text">
                            <h5>移动化</h5>
                            <p>便捷高效，全流程无缝链接全业务主体，智能终端RF极大提高仓内操作效率</p>
                        </div>
                    </div>
                    <div class="info">
                        <img class="icon" src="../../images/icon/icon_szh.png">
                        <div class="text">
                            <h5>数字化</h5>
                            <p>承载企业数字化转型，使用数据辅助精细化管理，数据运营指标量化助力合作操作界面效率优化</p>
                        </div>
                    </div>
                    <div class="info">
                        <img class="icon" src="../../images/icon/icon_znh.png">
                        <div class="text">
                            <h5>智能化</h5>
                            <p>技术引领未来，通过仓库自动化，智能终端，自动打印终端等极大提升基本操作环节效率，降低成本，建立核心竞争力</p>
                        </div>
                    </div>
                </div>
                <div class="img-wrap">
                    <viewer v-if="COMMON.isMobile">
                        <img class="picture" src="../../images/picture/qcks_lcpic.png">
                    </viewer>
                    <img class="picture" src="../../images/picture/qcks_lcpic.png" v-else>
                </div>
            </div>
        </ContentBox>
        <div class="example">
            <div class="container">
                <div class="tab">
                    <div class="tab-list">
                        <div class="tab-inner" v-for="(item,index) in img" :key="index" @click="showTab(index)">
                            <img
                                class="tab-img"
                                :src="img[index].show?img[index].url2:img[index].url1"
                            >
                            <span :class="{'tab-text': true, on:img[index].show}">{{img[index].name}}</span>
                        </div>
                    </div>
                </div>
                <div class="box">
                    <img class="box-inner" :src="img[index].urlBig">
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.visible {
    .img-wrap {
        padding: 0 .15rem;
    }
    img{
        max-width: 100%;
    }
    .title {
        font-size: 32px;
    }
    img {
        margin: 0 auto;
    }
    .system {
        padding: 0.6rem 0 0.8rem 0;
        text-align: center;
        .title {
            color: #333333;
            padding: 0.2rem 0;
        }
        .sub-title {
            font-size: 16px;
            line-height: 1.5em;
            padding: 0 0.2rem 0.3rem 0.2rem;
            max-width: 8rem;
            margin: 0 auto;
        }
        .icon {
            margin-bottom: 0.48rem;
        }
        .content {
            display: flex;
        }
        .info {
            width: 2.5rem;
            flex: 1;
            margin: 0.27rem;
        }
        h5 {
            font-size: 20px;
            color: #333333;
            margin-bottom: 0.2rem;
        }
        .picture{
            margin-top: 0.3rem;
        }
    }
    .example {
        background: #f8f9fa;
        .title {
            color: #333333;
            z-index: 10;
        }
        .flex {
            display: flex;
        }
        .box {
            margin: 1.2rem 0 0.8rem 0;
            border-radius: 0.2rem 0.2rem 0px 0px;
            background: #edeef3;
        }
        .box-inner {
            margin: 0 0.3rem;
            width: 1140px;
            position: relative;
            top: -0.6rem;
        }
        .tab {
            width: 100%;
        }
        .tab-list {
            width: 10.44rem;
            display: flex;
            padding: 0.75rem 0 0 0;
            margin: 0 auto;
        }
        .tab-inner {
            flex: 1;
            text-align: center;
            cursor: pointer;
        }
        .tab-text {
            padding: 0.26rem 0;
            display: block;
        }
        .tab-img {
            width: 0.6rem;
            height: 0.6rem;
            vertical-align: middle;
        }
        .on {
            background: url(../../images/icon/qcks_line_down.png) bottom center no-repeat;
        }
    }
}
@media screen and (max-width: 480px) {
    .visible {
        .title {
            font-size: 16px;
            padding: 0.15rem;
        }
        .system {
            padding: 0 0 0.2rem;
            .content {
                width: 100%;
                display: block;
                margin: 0;
                padding: 0 .15rem .15rem;
                box-sizing: border-box;
                text-align: left;
            }
            .info {
                width: 100%;
                flex: auto;
                min-width: 1rem;
                padding: .15rem 0;
                box-sizing: border-box;
                margin: 0 0 0.15rem 0;
                border: 1px solid #e6e6e6;
                &:last-child {
                    margin: 0;
                }
            }
            h5 {
                font-size: 14px;
                margin-bottom: .1rem;
            }
            .sub-title {
                padding-bottom: 0.1rem;
            }
            p {
                font-size: 12px;
                padding: 0 0.05rem;
            }
            .icon {
                width: 0.3rem;
                height: 0.3rem;
                padding: .15rem;
                margin-bottom: 0.1rem;
                float: left;
            }
            .picture {
                margin-top: 0;
            }
        }
        .example {
            padding: 0 .15rem 0.3rem .15rem;
            h5 {
                text-align: center;
                margin: 1em 0;
                font-size: 14px;
            }
            .tab {
                padding-bottom: .1rem;
            }
            .tab-list {
                width: auto;
                padding: 0;
                display: block;
                border-bottom: 1px solid #e6e6e6;
                text-align: center;
            }
            .tab-inner {
                display: inline-block;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }
            .tab-img {
                display: none;
            }
            .tab-text {
                position: relative;
                padding: .2rem .07rem .15rem;
            }
            .on {
                color: #0094ff;
                background: none;
                &:after {
                    content: '';
                    display: block;
                    width: .05rem;
                    height: .05rem;
                    background: #f8f9fa;
                    border: 1px solid #e6e6e6;
                    border-right: 0;
                    border-top: 0;
                    transform: rotate(135deg);
                    position: absolute;
                    left: 50%;
                    bottom: -0.03rem;
                    margin: 0 0 0 -.03rem;
                }
            }
            .box {
                margin: .3rem 0 0 0;
                padding: 0 .08rem;
            }
            .box-inner {
                margin: 0;
                width: 100%;
                height: auto;
                top: -.2rem;
            }
        }
    }
}
</style>
<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '安得智联-全程可视|数智化|智能仓储解决方案',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联全程可视,数智化,智能仓储解决方案'
        },{                 // set meta
            name: 'description',
            content: '安得智联全程可视,多维度实时监控可视业务运作全过程,丰富可视化图表提高数据的可读性,赋能全业务流程,实现数智化,智能仓储,提高仓内操作效率.'
        }]
    },
    name: 'visible',
    data() {
        return {
            index: 0,
            img: [
                {
                    name: '移动官网',
                    show: true,
                    url1: require('../../images/icon/icon_yd.png'),
                    url2: require('../../images/icon/icon_yd_select.png'),
                    urlBig: require('../../images/picture/qcks_yd_main.jpg')
                },
                {
                    name: '微信服务号',
                    show: false,
                    url1: require('../../images/icon/icon_wx.png'),
                    url2: require('../../images/icon/icon_wx_select.png'),
                    urlBig: require('../../images/picture/qcks_wx_main.jpg')
                },
                {
                    name: '直通宝',
                    show: false,
                    url1: require('../../images/icon/icon_ztb.png'),
                    url2: require('../../images/icon/icon_ztb_select.png'),
                    urlBig: require('../../images/picture/qcks_ztb_main.jpg')
                },
                {
                    name: '智能RF',
                    show: false,
                    url1: require('../../images/icon/icon_rf.png'),
                    url2: require('../../images/icon/icon_rf_select.png'),
                    urlBig: require('../../images/picture/qcks_rf_main.jpg')
                },
                {
                    name: '移动BI',
                    show: false,
                    url1: require('../../images/icon/icon_bi.png'),
                    url2: require('../../images/icon/icon_bi_select.png'),
                    urlBig: require('../../images/picture/qcks_bi_main.jpg')
                }
            ]
        };
    },
    components: {
        ContentBox
    },
    methods: {
        showTab(index) {
            this.img.map(item => {
                item.show = false;
            });
            this.img[index].show = true;
            this.index = index;
        }
    },
    mounted() {
    }
};
</script>